import { render, staticRenderFns } from "./DxBinsContentGrid.vue?vue&type=template&id=912bc370&scoped=true&"
import script from "./DxBinsContentGrid.vue?vue&type=script&lang=js&"
export * from "./DxBinsContentGrid.vue?vue&type=script&lang=js&"
import style0 from "./DxBinsContentGrid.vue?vue&type=style&index=0&id=912bc370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912bc370",
  null
  
)

export default component.exports